// České formátování. Datumy "5. 5. 2026", částky "87 862 Kč" (mezera + Kč za číslem).

export const fmtDate = (iso?: string | null): string =>
  iso ? new Date(iso).toLocaleDateString('cs-CZ') : '—';

export const fmtDateTime = (iso?: string | null): string =>
  iso ? new Date(iso).toLocaleString('cs-CZ') : '—';

export const fmtMoney = (amount: number, currency = 'CZK'): string =>
  new Intl.NumberFormat('cs-CZ', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(amount);

export const fmtNumber = (n: number): string => new Intl.NumberFormat('cs-CZ').format(n);
